<script lang="ts">
    import { browser } from '$app/environment';
    import { setCometDContext } from './cometd.store';
    import AdventurerUpdates from './AdventurerUpdates.svelte';

    import PlayerUpdates from './PlayerUpdates.svelte';
    import UmoboardsUpdates from './UmoboardsUpdates.svelte';
    import SessionUpdates from './SessionUpdates.svelte';

    if (browser) {
        setCometDContext();
    }
</script>

{#if browser}
    <SessionUpdates />
    <PlayerUpdates />
    <AdventurerUpdates />
    <UmoboardsUpdates />
{/if}
